





















import { Vue, Component, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import {
  Message,
  MESSAGE_TYPE_TOPLEVEL,
  messageTypeClassNames
} from '@/types/message'
import { Worker, Patient, User, isRelative } from '@/types/user'
import dayjs from 'dayjs'
import { getEnvVar } from '@/utils'

@Component({
  components: {
    Loading: () => import('@/components/common/loadings/Index.vue')
  }
})
export default class MessageHistory extends Vue {
  $store!: ExStore
  isRead = false

  @Prop() message!: Message

  get messageTypeClass() {
    return messageTypeClassNames[this.message.messageTypeLevel - 1]
  }

  get senderName() {
    const user = this.message.user
    return this.getUserName(user)
  }

  get senderOccupation() {
    const sender = this.message.user

    if (sender.heartlineId === getEnvVar('SYSTEM_USER_HL_ID')) {
      return ''
    }
    const occupationName = isRelative(sender)
      ? '家族'
      : sender.occupation
      ? sender.occupation.name
      : '患者'
    return this.isLoginUser(sender) ? '' : occupationName
  }

  get recipientNames() {
    const names = this.message.messageuserSet.map(user =>
      this.getUserName(user.user)
    )
    return names.join(', ')
  }

  get userInfo() {
    return this.$store.getters['user/userInfo']
  }

  get unread() {
    const muser = this.selfMessageUser
    if (!muser) return false
    return (
      !this.isSelfSender &&
      !this.isRead &&
      this.isEmergncyMessage &&
      !muser.isRead
    )
  }

  get isEmergncyMessage() {
    return this.message.messageTypeLevel >= MESSAGE_TYPE_TOPLEVEL
  }

  get selfMessageUser() {
    return this.message.messageuserSet.find(
      user => user.user.id == this.userInfo.id
    )
  }

  get timeStr() {
    return dayjs(this.message.registeredDatetime).format('HH:mm')
  }

  get isSelfSender() {
    return this.isLoginUser(this.message.user)
  }

  isLoginUser(user: User) {
    return user.id == this.userInfo.id
  }

  getUserName(user: User) {
    if (this.isLoginUser(user)) return '自分'
    return `${user.lastName}${user.firstName}`
  }

  handleRead() {
    const muser = this.selfMessageUser
    if (!muser) return false
    this.$api.message
      .patchRead({ id: muser.id })
      .then(res => {
        this.isRead = true
        this.$store.dispatch('message/updateUnreadHistory')
      })
      .catch(e => console.error(e))
  }
}
